import React from 'react';
import {EmprestimoProps, ModuleInjectedProps, PaymentModule} from './types';
import {EmprestimoHeader} from './components/EmprestimoHeader';
import {EmprestimoResume} from './components/EmprestimoResume';

function EmprestimoComponent(_props: EmprestimoProps) {
  return null;
}

EmprestimoComponent.Header = function Header({
  totalValue,
  installment,
  numero_parcela,
  data_vencimento,
}: EmprestimoProps & ModuleInjectedProps) {
  return (
    <EmprestimoHeader
      totalValue={totalValue}
      installment={installment}
      numero_parcela={numero_parcela}
      data_vencimento={data_vencimento}
    />
  );
};

EmprestimoComponent.Resume = function Resume({
  numero_parcela,
  data_vencimento,
  totalValue,
  installment,
  serviceTaxIsCard,
  serviceTaxValue,
  baseValue,
  usaBaratinhas,
  descontoBaratinhas,
}: EmprestimoProps & ModuleInjectedProps) {
  return (
    <EmprestimoResume
      numero_parcela={numero_parcela}
      data_vencimento={data_vencimento}
      totalValue={totalValue}
      installment={installment}
      serviceTaxIsCard={serviceTaxIsCard}
      serviceTaxValue={serviceTaxValue}
      baseValue={baseValue}
      usaBaratinhas={usaBaratinhas}
      descontoBaratinhas={descontoBaratinhas}
    />
  );
};

export const Emprestimo = EmprestimoComponent as PaymentModule<EmprestimoProps>;
